import { render, staticRenderFns } from "./InspectionHold.vue?vue&type=template&id=3acc8752&scoped=true&"
import script from "./InspectionHold.vue?vue&type=script&lang=ts&"
export * from "./InspectionHold.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionHold.vue?vue&type=style&index=0&id=3acc8752&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acc8752",
  null
  
)

export default component.exports